// import React from "react";
import { useState, useEffect } from "react";
import http from "../../services/http-commons.js";
// import { SetAllContext } from "../../services/AllContext.js";
// import NoWishList from "./NoWishList.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import "./AffiliateMarket.scss";

const AffiliateMarket = () => {
  //   const { userID } = useContext(SetAllContext);
  const navigate = useNavigate()
  // ==================== State =========================
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);
  const [affiliateDetails, setAffiliateDetails] = useState(null);
  const [activated, setActivated] = useState(true);
  const [bankeInfo, setBankInfo] = useState(null);
  const [onboardAffiliate, setOnboardAffiliate] = useState({
    affiliate_code: "",
    account_number: "",
    account_name: "",
    bank_name: "",
  });

  // =================== Effects =================
  useEffect(() => {
    http.AFFILIATEHTTP.get(`/affiliate-details`)
      .then((response) => {
        setActivated(true);
        setAffiliateDetails(response.data);
        setBankInfo(JSON.parse(response.data.acount_details));

        setError(null); // reset any previous error
      })
      .catch((error) => {
        setActivated(false);
        if (error.response) {
          // Server responded but with error status
          if (error.response.status === 404) {
            // User is not an affiliate → show onboarding
            setAffiliateDetails(null);
          } else if (error.response.status === 500) {
            // Server error → show an error message
            setError(
              "Something went wrong on the server. Please try again later.",
            );
          } else if (error.response.status === 401) {
            // Unauthorized → show an error message
            setError("Unauthorized. Please log in to continue.");
            setErrorCode(401);
          } else {
            setError(`An error occurred: ${error.response.data.detail}`);
          }
        } else if (error.request) {
          // No response from server (network error, timeout, etc.)
          setError("No response from server. Check your connection.");
        } else {
          // Something else (bad config, etc.)
          setError(`Error: ${error.message}`);
        }
      });
  }, [activated]);

  //  ============== Functions ================
  const handleCopy = () => {
    navigator.clipboard
      .writeText(
        `www.banke.com.ng/auth/register?affiliate_code=${affiliateDetails?.code}`,
      )
      .then(() => {
        toast.success(
          `Affiliate link copied to clipboard! Share it with your friends.`,
          {
            autoClose: 3000, // 3 seconds
          },
        );
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOnboardAffiliate((prev) => ({
      ...prev,
      [name]: name === "affiliate_code" ? value.toLowerCase() : value,
      //   [name]: value,
    }));
  };
  const requestAffiliatorPayment = () => {
    const payment_request = http.AFFILIATEHTTP.get("/request-payment");

    toast.promise(
      payment_request,
      {
        pending: "Requesting payment...",
        success: "Payment successfully Requested! 🎉",
        error: "Unable to request payment 😞",
      },
      {
        autoClose: 3000,
      },
    );
  };
  const registerAffiliate = () => {
    let onboardingBankData = {
      account_number: onboardAffiliate.account_number,
      account_name: onboardAffiliate.account_name,
      bank_name: onboardAffiliate.bank_name,
    };
    let onboardingData = {
      affiliate_code: onboardAffiliate.affiliate_code,
      account_details: JSON.stringify(onboardingBankData),
    };
    const registerNewAffiliate = http.AFFILIATEHTTP.post(
      "/affiliate-registration",
      onboardingData,
    );

    toast.promise(
      registerNewAffiliate,
      {
        pending: "Registering account...",
        success: "Account successfully Registered! 🎉",
        error: "Unable to register account 😞",
      },
      {
        autoClose: 3000,
      },
    );
    registerNewAffiliate
      .then(() => {
        setActivated(true);
      })
      .catch((error) => {
        setActivated(false);
        toast.error(
          `${
            error.response.data
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          },
        );
      });
  };

  return (
    <div className="affiliate-informataion">
      {/* {error && <p className="text-danger">{error}</p>} */}
      {error && errorCode === 401 ? (
      <div className="login-required-container">
        <div className="login-required-card">
          <div className="login-icon">🔐</div>

          <h2>Login Required</h2>

          <p>Please log in to your account to continue and access this page.</p>

          <button
            className="login-required-btn"
            onClick={() => navigate("/auth/login")}
          >
            Log In
          </button>
        </div>
      </div>
    ) : (
        error && <p className="text-danger">{error}</p>
      )}
      {!affiliateDetails && !error ? (
        <div className="onboard-affiliate">
          <div className="d-flex justify-content-between align-items-center">
            <h4>Create Affiliate Account</h4>
          </div>
          <hr />
          {/* Affiliate Code */}
          <div className="mb-3">
            <label htmlFor={"affiliateCode"} className="form-label">
              Affiliate Code
            </label>
            <input
              name="affiliate_code"
              type="text"
              value={onboardAffiliate.affiliate_code}
              onChange={handleInputChange}
              className="form-control form-control-lg"
              id={"affiliateCode"}
            />
          </div>
          {/* Account Number */}
          <div className="mb-3">
            <label htmlFor={"accountNumber"} className="form-label">
              Account Number
            </label>
            <input
              name="account_number"
              type="text"
              value={onboardAffiliate.account_number}
              onChange={handleInputChange}
              className="form-control form-control-lg"
              id={"accountNumber"}
            />
          </div>
          {/* Account Name */}
          <div className="mb-3">
            <label htmlFor={"accountName"} className="form-label">
              Account Name
            </label>
            <input
              name="account_name"
              type="text"
              value={onboardAffiliate.account_name}
              onChange={handleInputChange}
              className="form-control form-control-lg"
              id={"accountName"}
            />
          </div>
          {/* Bank Name */}
          <div className="mb-3">
            <label htmlFor={"bankName"} className="form-label">
              Bank Name
            </label>
            <input
              name="bank_name"
              type="text"
              value={onboardAffiliate.bank_name}
              onChange={handleInputChange}
              className="form-control form-control-lg"
              id={"bankName"}
            />
          </div>
          <button
            className="btn btn-outline-primary"
            onClick={registerAffiliate}
          >
            Register
          </button>
        </div>
      ) : affiliateDetails ? (
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <h4>Account Information</h4>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Affiliate Code</th>
                <th scope="col">Generated this Month</th>
                <th scope="col">Generated this Total</th>
                <th scope="col">Total Paid</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>{affiliateDetails?.code}</td>
                <td>
                  <strong>
                    <em>
                      ₦ {affiliateDetails?.month_generated.toLocaleString()}
                    </em>
                  </strong>
                </td>
                <td>
                  <strong>
                    <em>
                      ₦ {affiliateDetails?.total_generated.toLocaleString()}
                    </em>
                  </strong>
                </td>
                <td>
                  <strong>
                    <em>₦ {affiliateDetails?.total_paid.toLocaleString()}</em>
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="d-flex justify-content-start">
            <div className="text-start">
              <p>
                <strong>Account Number:</strong>{" "}
                <em>{bankeInfo?.account_number}</em>
              </p>
              <p>
                <strong>Account Name:</strong>{" "}
                <em>{bankeInfo?.account_name}</em>
              </p>
              <p>
                <strong>Bank Name:</strong> <em>{bankeInfo?.bank_name}</em>
              </p>
              <p style={{ textAlign: "center", marginTop: "20px" }}>
                <strong>Copy and share you affiliate link 👇🏼</strong> <br />
                <span
                  onClick={handleCopy}
                  style={{
                    cursor: "pointer",
                    color: "#0d6efd",
                    textDecoration: "underline",
                    fontStyle: "italic",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    backgroundColor: "#f1f8ff",
                    display: "inline-block",
                    wordBreak: "break-all",
                  }}
                >
                  www.banke.com.ng/auth/register?affiliate_code=
                  {affiliateDetails?.code}
                </span>
              </p>
            </div>
          </div>
          {affiliateDetails?.month_generated > 0 ? (
            <button
              className="btn btn-outline-primary"
              onClick={requestAffiliatorPayment}
            >
              Request payment
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default AffiliateMarket;
